// Authored preflop range set. ENGINE_DESIGN.md §4.1 (self-encoded JSON in data/ranges/*.json).
// This is the AUTHORED form (equilab-style strings), distinct from the runtime WeightedRange in
// range.ts. Minimal container by intent: the exact spot-key convention (RFI / vs-RFI / 3bet /
// vs-3bet × position × 6/9-max) is finalized at D1/S5; a string→string map keeps it open now while
// still letting D1 validate its files against a real schema.
import { z } from 'zod';
export const RangeSetSchema = z.object({
    /** matches an Archetype.preflop.rangeSetId, e.g. 'live_loose_9max'. */
    id: z.string(),
    /** versioned as a unit, e.g. 'ranges:v1'. */
    version: z.string(),
    tableSize: z.union([z.literal(6), z.literal(9)]),
    /** citation basis for SOURCES.md - never a redistributed PDF. */
    source: z.string(),
    /** spot key (e.g. 'CO_RFI', 'BB_vs_BTN_3bet') → equilab/PokerStove-style range string. */
    ranges: z.record(z.string(), z.string()),
});
//# sourceMappingURL=range-set.js.map